// src/lib/opportunity/formatCalcLineClient.ts

import { opportunityFetch } from "./opportunityFetch";
import type { OpportunityFormatKey } from "@/types/opportunity";
import type {
  FormatCalcAmountMode,
  FormatCalcLine,
  FormatCalcPlacement,
} from "./formatCalcLineTypes";

export function listFormatCalcLines(filters: {
  format_key: OpportunityFormatKey;
  product_type: string;
}) {
  const q = new URLSearchParams({
    format_key: filters.format_key,
    product_type: filters.product_type,
  });
  return opportunityFetch<{ ok: true; lines: FormatCalcLine[] }>(
    `/api/opportunity/format-calc-line-list?${q.toString()}`,
    { method: "GET" },
  );
}

export type UpsertFormatCalcLinePayload = {
  id?: string;
  format_key: OpportunityFormatKey;
  product_type: string;
  placement: FormatCalcPlacement;
  sort_order: number;
  label: string;
  amount_mode: FormatCalcAmountMode;
  default_amount: number;
  include_in_deposit: boolean;
  visible_on_proposal: boolean;
  commissionable: boolean;
};

export function upsertFormatCalcLine(payload: UpsertFormatCalcLinePayload) {
  return opportunityFetch<{ ok: true; line: FormatCalcLine }>(
    "/api/opportunity/format-calc-line-upsert",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
  );
}

export function deleteFormatCalcLine(id: string) {
  return opportunityFetch<{ ok: true }>("/api/opportunity/format-calc-line-delete", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id }),
  });
}

export function reorderFormatCalcLines(payload: {
  format_key: OpportunityFormatKey;
  product_type: string;
  placement: FormatCalcPlacement;
  ordered_ids: string[];
}) {
  return opportunityFetch<{ ok: true }>("/api/opportunity/format-calc-line-reorder", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}
